<template>
	<SelectedItems
		v-if="data.yesNo"
		:characteristic-items="meta.geo"
		:characteristic-type="meta.geoType"
		:selected="data.geo"
		none-info="Ich würde überall hin übersiedeln"
	/>
	<div v-else class="sub-values inline">
		<div class="sub-value">
			<div class="label">Nein</div>
		</div>
	</div>
</template>

<script>
import SelectedItems from "@/vue/characteristic/SelectedItems.vue";
import {mapState} from "vuex";

export default {
	components: {SelectedItems},

	props: {
		data: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapState('meta', ['meta'])
	}
}
</script>
